import { cn, Image } from '@ds';
import { ScsUrl } from '@icons';

export const CaseScsTransplant = ({ color }: { color: string }) => {
  return (
    <div className={cn(color, 'flex gap-2 items-center rounded-lg py-1 px-2 w-full')}>
      <Image alt="Static cold storage icon" src={ScsUrl} />
      <span className="text-s-m">Organ on static cold storage</span>
    </div>
  );
};
